import { get } from "../../../api/axiosApi";
import { env } from "utils/env";

const url = env.REACT_APP_LEASING_API_URL;

const getFolderHeaderAlpha = (documentId, siteId) => get(`${url}/leasingfolders/${documentId}/${siteId}/alpha/header`);

const exp = {
  getFolderHeaderAlpha
};
export default exp;
